$(function(){
  // ドメイン設定
  var url = $( location ).attr( 'href' );
  var article_domain = '';
  if( url.indexOf('localhost' ) > -1 ){
    article_domain = 'http://local.blog.osouji.support';
  } else {
    article_domain = 'https://osouji.support/column';
  }

  if ( $( '.latest-posts__list' ).length ) {
    $.ajax({
      type: 'GET',
      url: article_domain + '/wp-json/wp/v2/posts',
      data: { 
        categories: 4,
        order: 'desc',
        orderby: 'date'
      },
      dataType : 'json',
    }).done( function( response ) {
      $.each( response, function( i, v ){
        $( '.latest-posts__list' ).append( '<li class="latest-posts__item"><a href="' + v.link + '" class="latest-posts__link"><figure><img src="' + v.thumbnail_url + '"></figure><p class="latest-posts__art-ttl">' + v.title.rendered + '</p></a></li>' );
      });
    });
  }
});


//////////////////
// WEBPACK FOOTER
// ./app/assets/javascripts/articles/article.js
// module id = 8
// module chunks = 0